export const programDetailTour = {
  key: "programDetail",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="program-detail-root"]',
      content: t("Tour_ProgramDetail_Root"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="program-detail-opentasks"]',
      content: t("Tour_ProgramDetail_OpenTasks"),
      placement: "bottom",
    },
    {
      target: '[data-tour="program-detail-overdue"]',
      content: t("Tour_ProgramDetail_Overdue"),
      placement: "bottom",
    },
    {
      target: '[data-tour="program-detail-boards"]',
      content: t("Tour_ProgramDetail_Boards"),
      placement: "top",
    },
    {
      target: '[data-tour="program-detail-manageboards"]',
      content: t("Tour_ProgramDetail_ManageBoards"),
      placement: "top",
    },
    {
      target: '[data-tour="program-detail-dependencies"]',
      content: t("Tour_ProgramDetail_Dependencies"),
      placement: "top",
    },
  ],
};
